import { StyleSheet } from "aphrodite/no-important";
import { colour, width } from "../style/base-theme";

export const styles = StyleSheet.create({
  navigation: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#fff",
    borderTop: "1px solid #eee",
    boxShadow: "0 -2px 5px rgba(0,0,0,0.20)",
    zIndex: 998
  },
  innerContent: {
    maxWidth: width.outer,
    margin: "0 auto"
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  listItem: {
    flex: "1 0 0",
    textAlign: "center"
  },
  link: {
    textDecoration: "none",
    display: "block",
    padding: 12,
    color: colour.grey[300],
    ":hover": {
      background: colour.grey[600]
    }
  },
  iconToday: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E80D"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconUsage: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E80E"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconRankings: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E80C"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconAppliances: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E802"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconFeedback: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E805"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconAlerts: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E801"',
      display: "block",
      paddingBottom: 2
    }
  },
  iconActivities: {
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.grey[400],
      content: '"\\E800"',
      display: "block",
      paddingBottom: 2
    }
  },
  active: {
    color: colour.energy.primaryGradientTop,
    fontWeight: 600,
    ":before": {
      color: colour.energy.primaryGradientTop
    }
  },
  assistedActive: {
    color: colour.brand.darkBlue,
    fontWeight: 600,
    ":before": {
      color: colour.brand.darkBlue
    }
  },
  text: {
    display: "block",
    fontSize: 14
  }
});
